// used to render cell content components
import React from 'react';
import CybsStatusBadge from '@cybs-ui/components/lib/status-badge';
import renderStyles from '../styles/components.renderer.styles';

const StatusBadge = cell => {
  const _generateBadgeWithLabel = statusObj => {
    const { status, label, detailText, justifyText, statusIcon } = statusObj;
    _generateBadgeWithLabel.displayName = 'generateBadgeWithLabel';

    let detailTextLabel;

    if (detailText) {
      const cssProp =
        justifyText && justifyText === 'right' ? 'marginLeft' : 'marginRight';
      detailTextLabel = (
        <span
          style={{
            [cssProp]: '10px'
          }}
        >
          {detailText}
        </span>
      );
    }

    const renderOrder = [
      { idx: 0, component: detailTextLabel },
      { idx: 1, component: <CybsStatusBadge status={status} label={label} icon={statusIcon} /> }
    ];

    if (justifyText && justifyText === 'right' && detailText) {
      // used for rendering on either side of badte
      renderOrder.sort((a, b) => {
        if (a.idx > b.idx) return -1;
        if (a.idx < b.idx) return 1;
        return 0;
      });
    }
    return detailTextLabel ? (
      <div css={renderStyles.statusBadgeStyle}>
        {renderOrder.map(obj => obj && obj.component ? obj.component : null)}
      </div>
    ) : (
        <div css={renderStyles.statusBadgeStyle}>
          <CybsStatusBadge status={status} label={label} icon={statusIcon} />
        </div>
      );
  };

  const rowValue = cell.value;

  let comps = null;

  if (rowValue && rowValue.length) {
    // row Value is an array so map components
    comps = rowValue.map(statusObj => _generateBadgeWithLabel(statusObj));
  } else {
    const status = rowValue[cell.status];
    const label = rowValue[cell.label];
    const detailText = rowValue[cell.detailText];

    comps = _generateBadgeWithLabel(status, label, detailText);
  }

  return (
    <div // eslint-disable-next-line
      css={renderStyles.centerContentColumn}
    >
      {comps}
    </div>
  );
};

StatusBadge.displayName = 'generateCellStatusBadge';

export default StatusBadge;
